"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerProto = void 0;
class ServerProto {
    constructor(protoId, actions) {
        this.attach = (client) => {
            console.info('connected client', client.socket.remoteAddress);
            this.clients.push(client);
        };
        this.detach = (client) => {
            console.info('disconnected client', client.socket.remoteAddress);
            this.clients = this.clients.splice(this.clients.indexOf(client), 1);
        };
        this.msgRcv = (client, data) => {
            console.info('received message', data);
            if (data.protocol === this.PROTO_ID && this.actions.includes(data.action)) {
                console.log('match', this.PROTO_ID);
                this.onMessage(client, data);
            }
        };
        this.clients = [];
        this.PROTO_ID = protoId;
        this.actions = actions;
    }
    authorize(request) {
        return true;
    }
    onMessage(client, message) {
        console.info(`${this.constructor.name} from ${client.user} received ${message}`);
    }
    broadcast(action, data) {
        this.clients.forEach(client => this.send(client, action, data, 'multicast'));
    }
    send(client, action, data, cast = 'unicast') {
        client.ws.send(JSON.stringify(this.serialize(action, data, cast)));
    }
    serialize(action, data, cast) {
        return {
            cast,
            date: Date.now(),
            protocol: this.PROTO_ID,
            action,
            data
        };
    }
}
exports.ServerProto = ServerProto;
